export const getChargemapUrl = (path?: string) => {
    // Check if path starts with a leading /, if not add it
    if ((path && !path.startsWith('/')) || !path) {
        path = `/${path || ''}`
    }

    let url = `${useRuntimeConfig().public.CHARGEMAP_URL}/${useLanguage()}-${useCountry()}${path}`

    // Remove trailing slash if present
    if (url.endsWith('/')) {
        url = url.slice(0, -1)
    }

    return url
}

export const getAppStoreChargemapUrl = () =>
    `https://itunes.apple.com/${useCountry()}/app/chargemap-bornes-de-recharge/id438176982`

export const getPlayStoreChargemapUrl = () =>
    `https://play.google.com/store/apps/details?id=com.chargemap_beta.android&hl=${useLanguage()}`
